export default __webpack_public_path__ + "static/media/36I-102716_-15720_0.8da6cd58.jpg";